import styled from 'styled-components';

import { GhostButton } from 'ui/button';
import { colors, spacing } from 'ui/theme';

export const LinkButton = styled(GhostButton)`
  && {
    color: ${colors.textLink};
    text-decoration: underline;
    padding: 0 ${spacing.eighth};
    margin: 0 ${spacing.base} 0 -${spacing.single};
    height: auto;
    white-space: nowrap;

    &::before {
      left: 0;
      right: 0;
      border-radius: ${spacing.eighth};
    }

    &:focus {
      color: ${colors.linkFocus};
      :before {
        border-color: ${colors.linkFocusOutline};
      }
    }
    &:active {
      color: ${colors.linkActive};
    }
    &:hover {
      color: ${colors.linkHover};
      background-color: transparent;
    }
  }
`;
